const albums = [
  {
    id: 1,
    streams_count : 123456,
    type : "album",
    search_count: 100,
    title: "Pink Tape",
    genre:"hip hop",
    artist_id: 4,
    artist: "Lil Uzi Vert",
    cover_art: "https://i.scdn.co/image/ab67616d00001e02d5f96a807d04f42d0055d0f7",
    duration: "53 min 40 s",
    releaseDate: "10-septembre-2022",
    titleCount: 2,
  },
  {
    id: 2,
    type : "album",
    streams_count : 123456,
    search_count: 100,
    genre:"hip hop",
    title: "WE DON'T TRUST YOU",
    artist_id: 3,
    artist: "Metro Boomin",
    cover_art: "https://i.scdn.co/image/ab67616d00001e02d5f96a807d04f42d0055d0f7",
    duration: "45 min",
    releaseDate: "10-septembre-2022",
    titleCount: 2,
  },
  {
    id: 3,
    type : "album",
    streams_count : 123456,
    search_count: 100,
    genre:"pop",
    title: "This is Acting",
    artist_id: 2,
    artist: "Sia",
    cover_art: "https://i.scdn.co/image/ab67616d00001e02d1410c1372fab1e516328fa8",
    duration: "40 min",
    releaseDate: "10-septembre-2016",
    titleCount: 2,
  },
  {
    id: 4,
    type : "album",
    streams_count : 123456,
    search_count: 100,
    genre:"hip hop",
    title: "27",
    artist_id: 1,
    artist: "Elgrandetoto",
    cover_art: "https://i.scdn.co/image/ab67616d0000b2736e4a689465371b26f5787407",
    duration: "40 min",
    releaseDate: "10-septembre-2022",
    titleCount: 3,
  },
];

const getAlbumById = (albumId) => {
  const album = albums.find((album) => album.id === albumId);
  return album || null;
};

const getAlbumsByArtistId = (artistId) => {
  const albumsByArtist = albums.filter((album) => album.artist_id === artistId);
  return albumsByArtist;
};

const getPopularAlbumsByGenre = (genre) => {
  const searchGenre = genre.split('-').join(' ');
  return albums
    .filter((album) => album.genre === searchGenre)
    .sort((a, b) => b.streams_count - a.streams_count)
    .slice(0, 10);
};

const getRelatedAlbums = (albumId) => {
  const currentAlbum = albums.find((album) => album.id === albumId);
  if (!currentAlbum) {
    return [];
  }
  const relatedAlbums = albums.filter(
    (album) => album.artist_id === currentAlbum.artist_id && album.id !== albumId
  );
  return relatedAlbums;
};

const getPopularAlbumsByStreams = () => {
  return albums
    .sort((a, b) => b.streams_count - a.streams_count)
    .slice(0, 12);
};

const getPopularAlbumsBySearchCount = () => {
  return albums
    .sort((a, b) => b.search_count - a.search_count)
    .slice(0, 12);
};

const searchAlbumsByValue = (value, limit = 12) => {
  return albums
    .filter((item) => item.title.includes(value.toLowerCase()))
    .sort((a, b) => (b.streams || 0) - (a.streams || 0))
    .slice(0, limit);
};

export { getAlbumsByArtistId, getAlbumById, getPopularAlbumsByGenre, getRelatedAlbums, albums, getPopularAlbumsByStreams, getPopularAlbumsBySearchCount, searchAlbumsByValue };